import React, { createContext, useContext, useMemo } from "react";

const OrgSocialActorContext = createContext(null);

/**
 * Workplace Circa Social act-as-org context.
 * Present only under /orgs/:orgId/social/* — keeps browsing inside org chrome.
 */
export function OrgSocialActorProvider({
  orgId,
  basePath,
  canPublish,
  canManageSettings,
  orgProfile,
  presence,
  reloadShell,
  children,
}) {
  const value = useMemo(
    () => ({
      orgId,
      basePath,
      canPublish: Boolean(canPublish),
      canManageSettings: Boolean(canManageSettings),
      orgProfile: orgProfile || null,
      presence: presence || null,
      displayName:
        orgProfile?.display_name || presence?.org?.name || "Organization",
      handle: orgProfile?.username || null,
      reloadShell: reloadShell || null,
    }),
    [
      orgId,
      basePath,
      canPublish,
      canManageSettings,
      orgProfile,
      presence,
      reloadShell,
    ]
  );

  return (
    <OrgSocialActorContext.Provider value={value}>
      {children}
    </OrgSocialActorContext.Provider>
  );
}

export function useOrgSocialActor() {
  return useContext(OrgSocialActorContext);
}
